import React from "react"
import { IntlShape } from "react-intl"
import { INavTab } from "components/Shared/NavTabs/interfaces"
import { getLevel } from "./utils"
import * as paths from "constants/paths"
import Table from "./Table"

const VSMTabs: (intl: IntlShape) => Array<INavTab> = (intl) => [
	{
		text: intl.formatMessage(
			{
				id:
					"phronesis.transactional.application.commercial.benchmark.title.column.metric",
			},
			{ metric: getLevel("level") }
		),
		pathname:
			paths.ROOT_CONTEXT + paths.TRANSACTIONAL_VALUE_SHARED_MODEL_BY_LEVEL,
		component: <Table tab="level" />,
	},
	{
		text: intl.formatMessage(
			{
				id:
					"phronesis.transactional.application.commercial.benchmark.title.column.metric",
			},
			{ metric: getLevel("brand") }
		),
		pathname:
			paths.ROOT_CONTEXT + paths.TRANSACTIONAL_VALUE_SHARED_MODEL_BY_BRAND,
		component: <Table tab="brand" />,
		active: false,
	},
	{
		text: intl.formatMessage(
			{
				id:
					"phronesis.transactional.application.commercial.benchmark.title.column.metric",
			},
			{ metric: getLevel("channel") }
		),
		pathname:
			paths.ROOT_CONTEXT + paths.TRANSACTIONAL_VALUE_SHARED_MODEL_BY_CHANNEL,
		component: <Table tab="channel" />,
	},
	{
		text: intl.formatMessage(
			{
				id:
					"phronesis.transactional.application.commercial.benchmark.title.column.metric",
			},
			{ metric: getLevel("format") }
		),
		pathname:
			paths.ROOT_CONTEXT + paths.TRANSACTIONAL_VALUE_SHARED_MODEL_BY_FORMAT,
		component: <Table tab="format" />,
	},
	{
		text: intl.formatMessage(
			{
				id:
					"phronesis.transactional.application.commercial.benchmark.title.column.metric",
			},
			{ metric: getLevel("location") }
		),
		pathname:
			paths.ROOT_CONTEXT + paths.TRANSACTIONAL_VALUE_SHARED_MODEL_BY_LOCATION,
		component: <Table tab="location" />,
	},
]

export default VSMTabs
